import { render, staticRenderFns } from "./Forword.html?vue&type=template&id=2003c441&"
import script from "./Forword.js?vue&type=script&lang=js&"
export * from "./Forword.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports